import { SectionHeaderBar } from '../../common/components/SectionHeaderBar';

export interface BridgeEstimatesProps {}

export const BridgeEstimates = ({}: BridgeEstimatesProps) => {
    return (
        <>
            <SectionHeaderBar title={'Estimates'}></SectionHeaderBar>
        </>
    );
};
